import gql from 'graphql-tag'

export const GET_USER_AUTHENTICATED = gql`
  query {
    me {
      id
      username: name
      email
      avatar
      role
    }
  }
`
